import axios from '@/axios.js'

export default ({
  isRegistered: false,
  namespaced: true,
  state: {
    sectores: []
  },
  actions: {
    getSector (context, sectorId) {
      return new Promise((resolve, reject) => {
        axios.get(`/api/val_sectors/${sectorId}`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    getSectores ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('/api/val_sectors')
          .then((response) => {
            commit('setSectoresMutation', response.data['hydra:member'])
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    addSector ({ commit }, sector) {
      return new Promise((resolve, reject) => {
        axios.post('/api/val_sectors', sector)
          .then((response) => {
            commit('addSectorMutation', response)
            resolve(response)
          })
          .catch((error) => { 
            reject(error) 
          })
      })
    },
    deleteSector ({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.delete(`/api/val_sectors/${id}`)
          .then((response) => {
            commit('deleteSectorMutation', id)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    updateSector ({ commit }, sector) {
      return new Promise((resolve, reject) => {
        axios.patch(`/api/val_sectors/${sector.id}`, sector, { headers: {'Content-Type': 'application/merge-patch+json'} })
          .then((response) => {
            commit('updateSectorMutation', response.data)
            resolve(response)
          })
          .catch((error) => { reject(error) })
      })
    },
    emptySectores ({ commit }) {
      commit('emptySectoresMutation')
    }
  },
  mutations: {
    setSectoresMutation (state, sector) {
      state.sectores = sector
    },
    addSectorMutation (state, sector) {
      state.sectores.push(sector)
    },
    updateSectorMutation (state, sector) {
      const idx = state.sectores.findIndex((u) => u.id === sector.id) // Buscamos o índice do elemento no array do state
      state.sectores.splice(idx, 1, sector)
    },
    deleteSectorMutation (state, id) {
      const idx = state.sectores.findIndex((u) => u.id === id) // Buscamos o índice do elemento no array do state
      state.sectores.splice(idx, 1)
    },
    emptySectoresMutation (state) {
      // Vaciamos o store
      state.sectores = []
    }
  },
  modules: {}
})